// @flow
export const tabilityApiUrl = `https://${process.env.REACT_APP_TABILITY_API_URL || "badapi"}`;
export const tabilityAuthUrl = `https://${process.env.REACT_APP_TABILITY_AUTH_URL || "badapi"}`;

export const tabilityMobileUrl = `${process.env.REACT_APP_TABILITY_MOBILE_URL || "badapi"}`;
